import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Colors from "../../theme/Colours";

export const MainContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
}));

export const HeaderContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(2),
}));

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontSize: "2rem",
  fontWeight: 500,
}));

export const BackIconStyle = {
  position: "absolute",
  right: 0,
  cursor: "pointer",
  color: Colors.defaultFontColor,
  fontSize: "40px",
};

export const InfoSection = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: Colors.background2,
  padding: "16px",
  borderRadius: "8px",
  marginBottom: theme.spacing(4),
}));

export const InfoText = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  fontWeight: 500,
  fontStyle: "medium",
  marginRight: theme.spacing(1),
}));

export const MainContentLayout = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: theme.spacing(4),
  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
  },
}));

export const ProductListContainer = styled(Box)(({ theme }) => ({
  backgroundColor: Colors.background2,
  borderRadius: "12px",
  border: `1px solid ${Colors.countersBGColor}`,
  overflow: "hidden",
  width: "100%",
  flex: 1,
}));

export const ProductListItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  padding: "16px",
  backgroundColor: Colors.background2,
}));

export const ProductImage = styled("img")(({ theme }) => ({
  width: 80,
  height: 80,
  objectFit: "contain",
  flexShrink: 0,
}));

export const ProductTextBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));

export const ProductTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "1rem",
}));

export const ProductSubText = styled(Typography)(({ theme }) => ({
  fontSize: "13px",
  color: Colors.greyTextColor,
}));

export const SummaryCard = styled(Box)(({ theme }) => ({
  border: `1px solid ${Colors.countersBGColor}`,
  borderRadius: "12px",
  padding: "24px",
  width: "100%",
  maxWidth: "350px",
  backgroundColor: Colors.background2,
  alignSelf: "flex-start",
}));

export const AddressSection = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${Colors.countersBGColor}`,
  paddingBottom: "16px",
  marginBottom: "16px",
}));

export const AddressSectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 500,
  fontFamily: "Poppins, Arial, Helvetica, sans-serif, Inter",
  lineHeight: 1.75,
  letterSpacing: "1px",
  color: Colors.greytext,
  textTransform: "uppercase",
  borderBottom: `1px solid ${Colors.countersBGColor}`,
}));

export const AddressName = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  marginTop: theme.spacing(1),
  fontSize: "16px",
}));

export const AddressText = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
}));

export const ContactSectionTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  fontSize: "12px",
  fontWeight: 500,
  fontFamily: "Poppins, Arial, Helvetica, sans-serif, Inter",
  lineHeight: 1.75,
  letterSpacing: "1px",
  color: Colors.greytext,
  textTransform: "uppercase",
}));

export const SummaryRowContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  marginTop: theme.spacing(1),
}));

export const SummaryLabel = styled(Typography)<{ bold?: boolean }>(
  ({ bold }) => ({
    fontWeight: bold ? 500 : 300,
  })
);

export const SummaryValue = styled(Typography)<{
  bold?: boolean;
  green?: boolean;
}>(({ bold, green }) => ({
  fontWeight: bold ? 600 : 400,
  color: green ? Colors.progressColor : "inherit",
}));

export const PaymentNote = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  marginTop: theme.spacing(1),
}));

export const ProceedToPaymentButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(3),
  backgroundColor: Colors.primaryButtonOrange,
  color: "white",
  borderRadius: "4px",
  width: "100%",
  height: "51px",
  padding: "10px 24px",
  fontSize: "18px",
  fontWeight: 500,
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    backgroundColor: Colors.primaryButtonOrangeHover,
  },
}));
